<template>
  <div>
    <div>
    <table class="table is-fullwidth" v-show="locations.length">
      <thead>
      <tr>
        <th> &nbsp;&nbsp;</th>
        <th>Company</th>
        <th>Address</th>
        <th>Dock</th>
        <th>Contacts</th>
        <th>Date/Time</th>
      </tr>
      </thead>
      <tbody>
      <!--<template v-for="(location, index) in locations"> -->
      <tr is="location-picker-row" @edit="editLocation(index)" @delete="removeLocation(index)" v-for="(location, index) in locations" :key="index" v-model="locations[index]">
      </tr>
      <!--</template> -->
      </tbody>
    </table>

      <job-point-form v-if="showAddLocationForm" v-model="tempLocation" :min-date="$attrs['min-date']" @input="addLocation"/>

      <button class="button is-success add-new" @click="toggleInputForm" v-show="!showAddLocationForm">
        <font-awesome-icon icon="plus" />
        Add another location
      </button>
    </div>
  </div>
</template>

<script>
import { isEqual, isEmpty } from 'lodash-es'
import JobPointForm from '@/components/TransactionCreationWizard/JobPoint-Create'
import LocationPickerRow from '@/components/TransactionCreationWizard/LocationPicker-row'

const defaultLocation = () => ({
  CompanyRolodexContactKey1: null,
  CompanyRolodexContactKey2: null,
  CompanyRolodexJobLocationAddressKey: null,
  companyJobPointComments: null,
  companyJobPointDateEarliest: null,
  companyJobPointDateLatest: null,
  companyJobPointDock: null,
  companyJobPointType: null
})

export default {
  name: 'LocationPicker',

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tempLocation: defaultLocation(),
      locations: [],
      showAddLocationForm: false
    }
  },

  created() {
    this.locations = [...this.value]
  },

  components: {
    LocationPickerRow,
    JobPointForm
  },

  methods: {
    removeLocation(index) {
      const deleteCount = 1
      this.locations.splice(index, deleteCount)
    },

    editLocation(index) {
      const targetLocation = this.locations[index]
      // because everything is passed by reference in JS, we need to deep clone the object so that when its reset it
      // doesn't blow away the data we care about
      const editObject = {
        companyRolodexJobLocationName: targetLocation.companyRolodexJobLocation.companyRolodexJobLocationName,
        CompanyRolodexJobLocationAddressKey: targetLocation.CompanyRolodexJobLocationAddressKey,
        companyJobPointDateEarliest: targetLocation.companyJobPointDateEarliest,
        companyJobPointDateLatest: targetLocation.companyJobPointDateLatest,
        companyJobPointKey: targetLocation.companyJobPointKey,
        companyJobPointDock: targetLocation.companyJobPointDock,
        CompanyRolodexContactKey1: targetLocation.CompanyRolodexContactKey1,
        CompanyRolodexContactKey2: targetLocation.CompanyRolodexContactKey2,
        companyRolodexJobLocationAddresses: {
          ...targetLocation.companyRolodexJobLocation.companyRolodexJobLocationAddresses[0]
        }
      }
      this.tempLocation = editObject
      this.toggleInputForm(true)
    },

    async addLocation() {
      if (!isEmpty(this.tempLocation)) {
        // because everything is passed by reference in JS, we need to deep clone the object so that when its reset it
        // doesn't blow away the data we care about
        const newLocation = JSON.parse(JSON.stringify(this.tempLocation))
        if (newLocation.companyJobPointKey) {
          const existingKey = newLocation.companyJobPointKey
          const targetIndex = this.locations.findIndex((location) => location.companyJobPointKey === existingKey)
          this.locations.splice(targetIndex, 1, newLocation)
        } else {
          this.locations.push(newLocation)
        }
      }

      this.tempLocation = defaultLocation()
      this.toggleInputForm()
    },

    toggleInputForm(forcedValue) {
      if (forcedValue === undefined) {
        this.showAddLocationForm = !this.showAddLocationForm
      } else {
        this.showAddLocationForm = forcedValue
      }
    },

    notify() {
      if (!isEqual(this.locations, this.value)) {
        this.$emit('input', this.locations)
        this.$emit('save-hack')
      }
    }
  },

  watch: {
    locations: {
      deep: true,
      handler() {
        this.notify()
        if (this.locations.length) {
          this.showAddLocationForm = false
        } else {
          this.showAddLocationForm = true
        }
      }
    },
    value() {
      if (!isEqual(this.locations, this.value)) {
        this.locations = [...this.value]
      }
    }
  }
}
</script>


<style scoped lang="scss">
.location-input-form {
  margin-bottom: 15px;

  .save-location-btn {
    margin: 0 3px;
  }
}
</style>
